import { RootState } from '@src/store/store'
import { TariffsStateType } from '@src/store/ducks/tariffs/reducer'

export const selectTariffs = (state: RootState): TariffsStateType => state.tariffs

export const selectTariffsFreeBlockDays = (state: RootState) => selectTariffs(state).freeBlockDays
export const selectTariffsIsLoadingBlock = (state: RootState) => selectTariffs(state).isLoadingBlock
export const selectTariffsIsSuccessBlock = (state: RootState) => selectTariffs(state).isSuccessBlock
export const selectTariffsDopTariffs = (state: RootState) => selectTariffs(state).dopTariffs
export const selectTariffsIsLoading = (state: RootState) => selectTariffs(state).isLoading
export const selectTariffsAvailableTariff = (state: RootState) => selectTariffs(state).availableTariff
export const selectTariffsIsLoadingChangeTariff = (state: RootState) => selectTariffs(state).isLoadingChangeTariff
export const selectTariffsIsSuccessChangeTariff = (state: RootState) => selectTariffs(state).isSuccessChangeTariff
export const selectTariffInformations = (state: RootState) => selectTariffs(state).tariffInfo
export const selectTariffError = (state: RootState) => selectTariffs(state).error
export const selectTariffBlockTariffs = (state: RootState) => selectTariffs(state).blockTariffs
export const selectTariffBlockDescription = (state: RootState) => selectTariffs(state).blockDescription
